<div class="page-header--container white--curve" [ngStyle]="pageHeaderStyle">
    <div class="content--wrapper" style="padding-top: 64px;">
        <div class="row" style="justify-content: center;">
            <div class="col-12">
                <div #insertDotdotdot class="insert-dotdotdot" style="text-align:center;">
                    <h1 class="title insert-dotdotdot" style="font-size: 40px;">{{language.fmenu17}}</h1>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="content-inner">
    <div class="container">
        <section class="content-detail">
            <div class="row">
                <div rel="layout-detail">
                    <div>
                        <div *ngIf="language_flag == 'th'; else else_language_flag " class="info" style="height: 800px">
                            <embed src="../../../assets/media/pdf/ONEAM_PrivacyNotice.pdf" type="application/pdf" width="100%" height="100%">
                        </div>
                        <ng-template #else_language_flag>
                            <div class="info" style="height: 800px">
                                <embed src="../../../assets/media/pdf/ONEAM_PrivacyNotice_EN.pdf" type="application/pdf" width="100%" height="100%">
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>